<!--
    预约模块
-->
<template>
  <div id="appoint">
    <div class="appoint">
      <div class="appoint-form">
        <input
          v-model="userName"
          class="fullInput mb-normal"
          type="text"
          placeholder="请输入姓名"
        />
        <input
          v-model="userPhone"
          maxlength="11"
          class="fullInput mb-normal"
          type="text"
          placeholder="请输入手机号"
        />
        <input
          v-model="idNo"
          maxlength="18"
          class="fullInput mb-normal"
          type="text"
          placeholder="请输入您的身份证号码"
        />
      </div>
      <div @click="submit" class="submit" style="position: absolute;"></div>
      <p class="submitTip">*消费金将于用户中奖后7个工作日内发放至可提供有效身份证信息
的中奖用户的去哪儿账户</p>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      userName: "",
      idNo: "",
      userPhone: "",
    };
  },
  created() {

  },
  methods: {
    verifyForm() {
      return new Promise((resolve) => {
        var reg = /^1[3456789]\d{9}$/gi;
        let dialog = this.$dialog;
        if (this.userName == "") {
          dialog.alert({
            message: "请输入姓名",
          });
        } else if (this.userPhone == "") {
          dialog.alert({
            message: "请输入手机号",
          });
        } else if (!reg.test(this.userPhone)) {
          dialog.alert({
            message: "请输入正确的手机号",
          });
        } else if (this.idNo == ''){
          dialog.alert({
            message: "身份证不能为空",
          });
        } else {
          resolve();
        }
      });
    },
    submit() {
      this.verifyForm().then(() => {
        let params = {
          phone: this.userPhone,
          name: this.userName,
          idCard: this.idNo,
        };
        this.$axios.post("/changmatwo/rePrzie", params,{headers:{'Activity-Code':'SKRMONEY_202202'}}).then((res) => {
          if (res.code == 200) {
            this.$dialog.alert({
              message: "提交成功",
            });
            this.$emit("close");
          } else {
            this.$dialog.alert({
              message: res.message,
            });
          }
        });
      });
    }
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}
#appoint{
  position: absolute;
  width: 86%;
  bottom: 0;
  left: 7%;
}
.appoint-box {
  position: relative;
  border-top: 1px solid transparent;
}
.rule-btn {
  border: 1px solid #1c3855;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  padding-left: 5px;
  padding-right: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
  border-left: 0;
  font-size: 16px;
  position: absolute;
  left: 0;
  top: 3px;
  z-index: 10;
  cursor: pointer;
}
.appoint {
  margin-bottom: 22px;
  position: relative;
  width: calc(100% - 32px);
  margin-left: auto;
  margin-right: auto;
  &-box {
    width: 342px;
    padding-top:28px;
    background: #b6c8d3;
    border: 2px solid;
    border-image: linear-gradient(-36deg, #f2eae2, #dbb99a, #faf9f4, #f2eae2) 2
      2;
    box-shadow: 0px 1px 2px 0px rgba(158, 185, 201, 0.82);
  }
  &-form {
    padding-top: 1px;
    input,
    select {
      display: block;
      border: none;
      outline: none;
      height: 35px;
      background-color: transparent;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      padding-left: 20px;
      padding-right: 20px;
      color: #525252;
      font-size: 12px;
    }
    input::placeholder,
    select {
      color: #525252;
    }
    .fullInput {
      width: 100%;
      padding-left: 11px;
      background: #fff;
    }
    .mb-normal {
      margin-bottom: 7px;
    }
  }
}
.submit {
  position: absolute;
  width: 75px;
  left: 172px;
  top: -84px;
  height: 45px;
  cursor: pointer;
}
.submitTip {
  width: 256px;
  height: 21px;
  font-size: 8px;
  font-family: FZZhunYuan-M02S;
  font-weight: 400;
  color: #FD5B1F;
  line-height: 16px;
}
.smscode {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-box-align: center;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  -webkit-text-size-adjust: center;
  margin-top: 15px;
  padding-left: 0 !important;
  width: calc(100% - 30px);
  margin-left: auto;
  margin-right: auto;
  &-lf {
    width: 156px;
    height: 35px;
    border: 1px solid #b9b9b9;
    text-align: center;
    background-color: #fff0c2;
    border-radius: 3px;
    input {
      text-align: center;
      padding-left: 0;
      width: 162px;
    }
  }
  &-rt {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-box-align: center;
    .codeNum {
      width: 93px;
      height: 35px;
      overflow: hidden;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      -webkit-box-align: center;
      justify-content: center;
      -webkit-text-size-adjust: center;
      img {
        height: 35px;
        display: block;
      }
    }
    .refresh {
      width: 20px;
      height: 20px;
      margin-left: 10px;
    }
  }
}
</style>